module.exports = __webpack_public_path__ + "static/media/img-destaque-home.878f02b6.jpg";